import * as React from "react";
import { useState, useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Box,
  Paper,
  Typography,
  Tab,
  Tabs,
  TextField,
  InputAdornment,
  Button,
  Container,
  Fab,
  useTheme,
  useMediaQuery,
  IconButton,
  Tooltip,
  Breadcrumbs,
  Link,
} from "@mui/material";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import Chip from "@mui/material/Chip";
import { esES } from "@mui/x-data-grid/locales";
import axios from "axios"; 
// Importación de Iconos
import ListAltIcon from "@mui/icons-material/ListAlt";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import SearchIcon from "@mui/icons-material/Search";
import BuildIcon from "@mui/icons-material/Build";
import FullscreenIcon from "@mui/icons-material/Fullscreen";
import FullscreenExitIcon from "@mui/icons-material/FullscreenExit";
import HomeIcon from "@mui/icons-material/Home";
import GroupsOutlined from "@mui/icons-material/GroupsOutlined";
import { School } from "@mui/icons-material";

//Componentes Importados
import Restricted from "components/Restricted";

// --- DATOS DE EJEMPLo (CORTO Y ORIGINAL) ---
const allRows = [
  {
    id: 1,
    usuario: "Ana Torres",
    examen: "Matemáticas 101",
    categoria: "Ciencias",
    dificultad: "Fácil",
    estado: "Aprobado",
  },
  {
    id: 2,
    usuario: "Luis Gomez",
    examen: "Historia del Arte",
    categoria: "Humanidades",
    dificultad: "Intermedio",
    estado: "Reprobado",
  },
  {
    id: 3,
    usuario: "Ana Torres",
    examen: "Química General",
    categoria: "Ciencias",
    dificultad: "Difícil",
    estado: "Aprobado",
  },
];

// --- DEFINICIÓN DE COLUMNAS ---
const columns = [
  { field: "id", headerName: "ID", width: 70 },
  { field: "usuario", headerName: "Nombre de Usuario", minWidth: 150, flex: 1 },
  { field: "examen", headerName: "Examen Tomado", minWidth: 150, flex: 1 },
  { field: "categoria", headerName: "Categoría", minWidth: 120, flex: 1 },
  { field: "dificultad", headerName: "Dificultad", width: 120 },
  {
    field: "estado",
    headerName: "Estado",
    width: 130,
    renderCell: (params) => (
      <Chip
        label={params.value}
        color={params.value === "Aprobado" ? "success" : "error"}
      />
    ),
  },
];

export default function TestDashboard() {
  const [tabValue, setTabValue] = useState(0);
  const [searchText, setSearchText] = useState("");
    // --- CAMBIO AQUÍ: Nuevos estados para manejar los datos de la API ---
    const [allRows, setAllRows] = useState([]); // Almacenará los datos originales de la API
    const [filteredRows, setFilteredRows] = useState([]); // Para mostrar en la tabla (filtrados)
    const [loading, setLoading] = useState(true); // Para el indicador de carga
    const [error, setError] = useState(null); // Para manejar errores de la API
  const [isFullScreen, setIsFullScreen] = useState(false);

  // Se mantiene el estado controlado, que es el patrón correcto
  const [paginationModel, setPaginationModel] = useState({
    pageSize: 20,
    page: 0,
  });

  const tableContainerRef = useRef(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const nav = useNavigate();

  const [items, setItems] = React.useState([]);
  useEffect(() => {
    const items = JSON.parse(localStorage.getItem("token"));
    if (items) {
      setItems(items);
    }
  }, []);

  const rol = items.rol;
// --- CAMBIO AQUÍ: Función para llamar a la API ---
const obtenerIntentosDeExamen = async () => {
  setLoading(true);
  setError(null);
  try {
    // Reemplaza esta URL con tu endpoint de backend si es diferente
    // Asume que la URL base de axios ya está configurada a /api
    const response = await axios.get("/intentosExamen");
    
    console.log("Datos de la API recibidos:", response.data);
    setAllRows(response.data); // Guardar datos originales

  } catch (err) {
    console.error("Error al obtener los intentos de examen:", err);
    const errorMessage = err.response?.data?.error || "No se pudieron cargar los datos. Intente de nuevo más tarde.";
    setError(errorMessage);
  } finally {
    setLoading(false);
  }
};

// --- CAMBIO AQUÍ: useEffect para cargar los datos al montar el componente ---
useEffect(() => {
  obtenerIntentosDeExamen();
}, []); // El array vacío [] asegura que se ejecute solo una vez al inicio
  function handleClickBreadCrumbs(event) {
    event.preventDefault();
  }

  const handleLinkHome = (event, message) => {
    if (message === "home") nav("/inicio");
  };
  const handleLinkGestion = (event, message) => {
    if (message === "gestion") nav("/gestionhumana");
  };

  const handleNavigateToCreator = () => {
    nav("/crearTest");
  };

  const handleFullScreenToggle = () => {
    if (!isFullScreen) {
      if (tableContainerRef.current) {
        tableContainerRef.current.requestFullscreen();
      }
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      }
    }
  };

  useEffect(() => {
    const handleFullScreenChange = () => {
      setIsFullScreen(!!document.fullscreenElement);
    };
    document.addEventListener("fullscreenchange", handleFullScreenChange);
    return () =>
      document.removeEventListener("fullscreenchange", handleFullScreenChange);
  }, []);

 // --- CAMBIO AQUÍ: La lógica de filtrado ahora depende del estado 'allRows' ---
 useEffect(() => {
  let newFilteredRows = [...allRows]; // Inicia con los datos completos de la API

  // El resto de la lógica de filtrado es la misma
  if (tabValue === 1)
    newFilteredRows = newFilteredRows.filter(
      (row) => row.estado === "Aprobado"
    );
  else if (tabValue === 2)
    newFilteredRows = newFilteredRows.filter(
      (row) => row.estado === "Reprobado"
    );
  
  if (searchText) {
    const normalizeText = (text) =>
      text
        .toString()
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "");
    const normalizedSearchText = normalizeText(searchText);
    newFilteredRows = newFilteredRows.filter((row) =>
      Object.values(row).some((val) =>
        normalizeText(String(val)).includes(normalizedSearchText) // Añadido String() para seguridad
      )
    );
  }
  setFilteredRows(newFilteredRows);
}, [tabValue, searchText, allRows]); // <- allRows es ahora una dependencia


  return (
    <div className="exclude">
      {rol === "1" || rol === "2" || rol === "7" ? (
        <>
          <Box sx={{ m: { xs: "1.5rem 1rem", sm: "1.5rem 2.5rem" } }}>
            <Box
              role="presentation"
              onClick={handleClickBreadCrumbs}
              sx={{ mb: 3 }}
            >
              <Breadcrumbs aria-label="breadcrumb">
                <Link
                  underline="hover"
                  sx={{ display: "flex", alignItems: "center" }}
                  color="inherit"
                  href="/inicio"
                  onClick={(event) => handleLinkHome(event, "home")}
                >
                  <HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                  Inicio
                </Link>
                <Link
                  underline="hover"
                  sx={{ display: "flex", alignItems: "center" }}
                  color="inherit"
                  href="/gestionhumana"
                  onClick={(event) => handleLinkGestion(event, "gestion")}
                >
                  <GroupsOutlined sx={{ mr: 0.5 }} fontSize="inherit" />
                  Gestión Humana
                </Link>
                <Typography
                  sx={{ display: "flex", alignItems: "center" }}
                  color="text.primary"
                >
                  <School sx={{ mr: 0.5 }} fontSize="inherit" />
                  Gestión de Exámenes
                </Typography>
              </Breadcrumbs>
            </Box>
            <Box>
              <Container maxWidth="xl" sx={{ px: "0 !important" }}>
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  mb={2}
                >
                  <Typography variant="h3" component="h1">
                    <b>Gestión de Exámenes</b>
                  </Typography>
                  <Box
                    sx={{
                      display: { xs: "none", sm: "flex" },
                      justifyContent: "flex-end",
                      mb: 2,
                    }}
                  >
                    <Button
                      variant="contained"
                      startIcon={<BuildIcon />}
                      sx={{
                        backgroundColor: "teal",
                        "&:hover": { backgroundColor: "darkcyan" },
                      }}
                      onClick={handleNavigateToCreator}
                    >
                      Constructor de Exámenes
                    </Button>
                  </Box>
                </Box>

                <Paper
                  elevation={3}
                  sx={{
                    borderRadius: 4,
                    p: { xs: 1.5, sm: 3 },
                    bgcolor: theme.palette.background.alt,
                  }}
                >
                  <Box
                    sx={{
                      borderBottom: 1,
                      borderColor: "divider",
                      width: "100%",
                    }}
                  >
                    <Tabs
                      value={tabValue}
                      onChange={(e, val) => setTabValue(val)}
                      variant={isMobile ? "scrollable" : "fullWidth"}
                      scrollButtons="auto"
                      allowScrollButtonsMobile
                    >
                      <Tab
                        icon={<ListAltIcon />}
                        iconPosition="start"
                        label="Todos"
                      />
                      <Tab
                        icon={<CheckCircleOutlineIcon />}
                        iconPosition="start"
                        label="Aprobados"
                      />
                      <Tab
                        icon={<HighlightOffIcon />}
                        iconPosition="start"
                        label="Reprobados"
                      />
                    </Tabs>
                  </Box>

                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      my: 2,
                    }}
                  >
                    <Tooltip
                      title={
                        isFullScreen
                          ? "Salir de pantalla completa"
                          : "Ver en pantalla completa"
                      }
                    >
                      <IconButton onClick={handleFullScreenToggle}>
                        {isFullScreen ? (
                          <FullscreenExitIcon />
                        ) : (
                          <FullscreenIcon />
                        )}
                      </IconButton>
                    </Tooltip>
                    <TextField
                      size="small"
                      variant="outlined"
                      value={searchText}
                      onChange={(e) => setSearchText(e.target.value)}
                      placeholder="Buscar..."
                      sx={{ width: { xs: "calc(100% - 50px)", sm: "300px" } }}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <SearchIcon />
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Box>

                  <Box
                    ref={tableContainerRef}
                    sx={{
                      width: "100%",
                      borderRadius: 4,
                      overflow: "hidden",
                      bgcolor: theme.palette.background.alt,
                    }}
                  >
                    <DataGrid
                      autoHeight
                      rows={filteredRows}
                      columns={columns}
                      sx={{
                        "& .MuiDataGrid-columnHeaders": { fontWeight: "bold" },
                        "& .MuiDataGrid-row:nth-of-type(even)": {
                          backgroundColor: "grey.25",
                        },
                        border: 0,
                      }}
                      paginationModel={paginationModel}
                      onPaginationModelChange={setPaginationModel}
                      rowCount={filteredRows.length} 
                      pageSizeOptions={[20, 50, 100]}

                      checkboxSelection
                      disableRowSelectionOnClick
                      slots={{ toolbar: GridToolbar }}
                      localeText={
                        esES.components.MuiDataGrid.defaultProps.localeText
                      }
                    />
                  </Box>
                </Paper>
              </Container>
              <Fab
                aria-label="constructor-examenes"
                sx={{
                  display: { xs: "flex", sm: "none" },
                  position: "fixed",
                  bottom: 24,
                  right: 24,
                  width: 70,
                  height: 70,
                  backgroundColor: "teal",
                  "&:hover": { backgroundColor: "darkcyan" },
                }}
                color="primary"
                onClick={handleNavigateToCreator}
              >
                <BuildIcon sx={{ fontSize: 35 }} />
              </Fab>
            </Box>
          </Box>
        </>
      ) : (
        <Box m="1.5rem 2.5rem">
          <Restricted />
        </Box>
      )}
    </div>
  );
}
